import { Currency } from "./currency.type";
import { UnitOfMeasurement } from "./unitOfMeasurement.type";

export enum OrderType {
  SALE = "Продажа",
  PURCHASE = "Покупка",
}
export enum Kind {
  MATERIAL = "Материал",
  PRODUCE = "Продукция",
}
export enum OrderStatus {
  PENDING = "В ожидании",
  ACCEPTED = "Принято",
  REVIEWED = "Проверен",
}
export interface Order {
  _id: string;
  date: string;
  clientId: string;
  clientName: string;
  type: OrderType;
  kind: Kind;
  kindId: string;
  name: string;
  unitOfMeasurement: UnitOfMeasurement;
  currency: Currency;
  price: { USD: number; TJS: number };
  exchangeRate: number;
  total: number;
  totalKg?: number;
  residueKgUnit?: string;
  returned: number;
  totalCost: { USD: number; TJS: number };
  profit: { USD: number; TJS: number };
  paid: number;
  receipt: string;
  ownerId: string;
  ownerName: string;
  discount: number;
  residueAfter: number;
  residueBefore: number;
  status: OrderStatus;
  description?: string;
  balanceBefore?: number;
  balanceAfter?: number;
  taskOrderId?: string;
}
